import { BlockCore } from '../../models/BlockModel/BlockCore'
import { BLOCK_ORDER, FIELDS_BLOCK_CONFIGS } from './config'

export const bankBlockCore = new BlockCore(FIELDS_BLOCK_CONFIGS, BLOCK_ORDER)
